(function($)
{

    $.fn.msxiautosearch = function(options)
    {
        // build main options before element iteration
        var opts = $.extend({}, $.fn.msxiautosearch.defaults, options);

        return this.each(function()
                         {
                             var $this = $(this);
                             // build element specific options
                             var eOpts = $.metadata ? $.extend({}, opts, $this.metadata()) : opts;
                             eOpts = $.fn.dataset ? $.extend({}, eOpts, $this.dataset()) : eOpts;

                             // todo caching. Could cache results in a hash
                             var $input = $this.find('input:text');
                             var $hiddenInput = eOpts['hiddenInput'] ? $(eOpts['hiddenInput']) : $this.find('input:hidden');
                             var $target = $this.find('.results');

                             var val = $input.val();
                             var minLength = eOpts['minLength'] || 1;

                             if(val.length >= minLength && !$input.hasClass('placeholder')) {
                                 search($input, $hiddenInput, $target, eOpts);
                             }

                             $input.keypress(function(e){
                                 if(e.which == 13)
                                 {
                                     // Prevent submit on enter
                                     return false;
                                 }
                             });

                             $input.keyup(function(){ onChange($input, $hiddenInput, $target, eOpts); });
                             $input.bind('cut',function(){ onChange($input, $hiddenInput, $target, eOpts); });
                             $input.bind('paste',function(){ onChange($input, $hiddenInput, $target, eOpts); });
                         });
    };
    //
    // plugin defaults
    //
    $.fn.msxiautosearch.defaults = {
        'url' : '',
        'params' : {},
        "minLength": 3,
        delay: 300,
        hiddenInput: '', // Selector for custom hidden input field(s)
        'renderResult': function(result){
            var $detailPanel = $('<div />').addClass('selected-detail');
            for(var field in result) {
                if(field != 'id' && field != 'label' && result[field]) {
                    var $label = $('<label />').append(field + ': ');
                    var $span = $('<span />').append(result[field]);
                    $detailPanel.append($('<div />').append($label).append($span));
                }
            }
            return $('<li />').addClass('result ui-state-default ui-corner-all ui-helper-reset')
                    .append($('<a href="#" />').append(result.label))
                    .append($detailPanel);
        }
    };

    function onChange($input, $hiddenInput, $target, eOpts) {
        var val = $input.val();
        var minLength = eOpts['minLength'] || 1;
        if(val.length >= minLength && !$input.hasClass('placeholder') && val != $input.data('val'))
        {
            clearTimeout($input.searching);
            $input.searching = setTimeout(function() {
                search($input, $hiddenInput, $target, eOpts);
            }, eOpts['delay']);
        }
    }

    function search($input, $hiddenInput, $target, eOpts){
        $input.addClass('searching');
        var val = $input.val();
        var params = $.extend({}, eOpts['params'], {term: val});
        $input.data('val', val);

        $.ajax({
                   url: eOpts['url'],
                   data: params,
                   dataType: 'json',
                   traditional: true,
                   success: function(results)
                   {
                       $target.empty();
                       for(var i = 0; i < results.length; i++)
                       {
                           var result = results[i];
                           var $rendered = eOpts['renderResult'].call($input, result);
                           $target.append($rendered);
                           $rendered.data('id', result.id);
                           $rendered.hover(function()
                                           {
                                               $(this).addClass('ui-state-hover');
                                           }, function()
                           {
                               $(this).removeClass('ui-state-hover');
                           });
                           $rendered.click(function()
                                           {
                                               var $selected = $(this);
                                               $selected.addClass('selected ui-state-active').siblings().removeClass('selected ui-state-active');
                                               $hiddenInput.val($selected.data('id')).change();
                                           });

                           if($hiddenInput.val() == result.id) {
                               $rendered.addClass('selected ui-state-active');
                           }
                       }
                       $input.removeClass('searching');
                   }
               });
    }


})(jQuery);